import React, { Component } from "react";
import { LocaleUtil } from "@eres/core";
import { PickerItem } from "./Picker";


interface Props {
	id: string;
	label?: string;
	required?: boolean;
	items?: PickerItem[];
	value?: PickerItem;
	onSelect?: ( value: PickerItem ) => void;
	selectClassName?: string;
	containerClassName?: string;
	error?: string;
}

interface State {

}

class SwitchStrip extends Component<Props, State> {
	static defaultProps: Partial<Props> = {
		containerClassName: "form-group",
		selectClassName: "form-control"
	};

	render() {
		const { id, label, required, items, value } = this.props;

		return (
			<React.Fragment>
				<div className={ this.props.containerClassName }>
					<label htmlFor={ id }>{ label }
						{ required && "*" }
					</label>
					<div className="btn-group btn-group-toggle login-btn-group" data-bs-toggle="buttons">
						{ items && items.map( ( item ) => {
							const isSelected = value && value.id === item.id;
							return <label
								className={ "btn " + ( isSelected ? "active" : "" ) } key={ item.id }
								onClick={ () => {
									this.props.onSelect?.( item );
								} }>
								<input
									type="radio" name={ item.id } id={ item.id }
									checked={ isSelected === true }
									onChange={ () => {
									} }
								/> { LocaleUtil.getLocalValue( item.value ) }
							</label>;
						} ) }
					</div>
					{ this.props.children }
				</div>
				{ this.props.error && <div className="invalid-feedback invalid-feedback-x">
					{ this.props.error }
				</div> }
			</React.Fragment>
		);
	}
}

export default SwitchStrip;
